import { Component, Inject, Input, Output, OnInit, EventEmitter } from '@angular/core';
import moment from 'moment';

@Component({
    selector: 'app-single-date-picker',
    templateUrl: './single-date-picker.component.html',
    styleUrls: ['./single-date-picker.component.scss'],
    standalone: false
})
export class SingleDatePickerComponent {
	rangePickerOptions: any = {
		locale: {
			format: 'DD/MM/YYYY',
			separator: ' - ',
			applyLabel: 'Aplicar',
			cancelLabel: 'Cancelar',
			fromLabel: 'De',
			toLabel: 'Até',
			customRangeLabel: 'Personalizado',
			daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
		},
		alwaysShowCalendars: true,
		singleDatePicker: true,
		startDate: undefined,
		endDate: undefined,
		autoUpdateInput: true
	};

	@Input()
	required: boolean;

	@Input()
	requiredMessage: string;

	@Input()
	fieldName: string;

	@Output()
	onDateChanged = new EventEmitter<Date>();

	@Input()
	date: Date;

	constructor() {
		this.rangePickerOptions.startDate = undefined;
		this.rangePickerOptions.endDate = undefined;
	}

	selectedDate(value: any): void {
		 this.setRange(value.startDate, value.endDate);
	}

	setRange(start: moment.Moment, end: moment.Moment): void {
		if (!start || !start.isValid() || !end || !end.isValid()) {
			start = undefined;
			end = undefined;
		}

		this.rangePickerOptions.startDate = start;
		this.rangePickerOptions.endDate = end;

		this.date = start.toDate();
		this.onDateChanged.emit(this.date);
	}

	get currentDate(): string {
		if (this.date) {
			return moment(this.date).format('DD/MM/YYYY');
		} else {
			return '';
		}
	}
}
